import { useQuery } from "@tanstack/react-query";
import { Smartphone, Download, ExternalLink, Bell, WifiOff } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Eyebrow } from "./Common";
import { get, HZ_APP_URL } from "@/lib/api";

export const AppDownload = () => {
  const { data: rel } = useQuery({ queryKey: ["app-release"], queryFn: () => get("/app-release"), retry: false });
  const hasApk = !!(rel && (rel.available ?? rel.version ?? rel.filename));
  return (
    <section id="app" data-testid="app-download-section" className="overflow-hidden rounded-3xl bg-orange-600 text-white">
      <div className="grid items-center gap-10 p-8 md:grid-cols-[1.3fr_1fr] md:p-12">
        <div>
          <Eyebrow light>La app HandyZoom</Eyebrow>
          <h2 className="mt-3 font-heading text-3xl font-extrabold tracking-tight sm:text-4xl">Lleva HandyZoom en tu móvil.</h2>
          <p className="mt-3 max-w-lg text-orange-50">Es la misma cuenta y los mismos datos que en esta web: tus solicitudes, presupuestos, citas, chat y facturas se sincronizan al momento.</p>
          <ul className="mt-5 grid gap-2 text-sm text-orange-50 sm:grid-cols-2">
            <li className="flex items-center gap-2"><Bell className="size-4" />Avisos de nuevos presupuestos</li>
            <li className="flex items-center gap-2"><WifiOff className="size-4" />Se instala como app, sin tienda</li>
          </ul>
          <div className="mt-7 flex flex-wrap gap-3">
            <Button asChild size="lg" className="rounded-xl bg-white text-orange-700 hover:bg-orange-50">
              <a href={`${HZ_APP_URL}/app`} target="_blank" rel="noreferrer" data-testid="install-app-btn"><Smartphone />Instalar la app</a>
            </Button>
            {hasApk && (
              <Button asChild size="lg" variant="outline" className="rounded-xl border-white/60 bg-transparent text-white hover:bg-white/10 hover:text-white">
                <a href={`${HZ_APP_URL}/api/app-release/apk`} data-testid="download-apk-btn"><Download />Descargar APK Android</a>
              </Button>
            )}
            <Button asChild size="lg" variant="ghost" className="rounded-xl text-white hover:bg-white/10 hover:text-white">
              <a href={HZ_APP_URL} target="_blank" rel="noreferrer" data-testid="open-app-btn"><ExternalLink />Abrir en el navegador</a>
            </Button>
          </div>
        </div>
        <div className="relative mx-auto hidden w-56 md:block">
          <div className="rounded-[2.2rem] border-[6px] border-slate-950 bg-white p-3 shadow-2xl">
            <div className="rounded-2xl bg-slate-950 p-4 text-white">
              <div className="font-heading font-extrabold">Handy<span className="text-orange-500">Zoom</span></div>
              <div className="mt-6 text-xs text-slate-400">Fuga bajo el fregadero</div>
              <div className="mt-1 inline-flex rounded-full bg-sky-100 px-2 py-0.5 text-[10px] font-semibold text-sky-800">Recibiendo presupuestos</div>
            </div>
            <div className="mt-3 space-y-2">
              {["Presupuesto recibido", "Cita confirmada", "Factura con IVA"].map((t) => (
                <div key={t} className="rounded-xl border border-slate-200 px-3 py-2 text-xs font-semibold text-slate-700">{t}</div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
